import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const allocationConstruction = async () => {
  const token = getToken();
  let valid = false;

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/construction_allocation`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      var result = await response.json();
      valid = result && result.success;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors)
      return {
        valid: false,
        message: result.errors,
      };
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
    fame: result.fame,
    hvo: result.hvo,
  };
};

export default allocationConstruction;
